<template>
    <div class="flex lb-circle-container">
        <div class="flex flex-col flex-grow">
            <div>
                <section class="hero is-small lb-circle-header">
                    <div class="hero-body">
                        <div class="notification is-primary is-light has-text-black">
                            <div class="level">
                                <div class="level-left">
                                    <div class="level-items">
                                        <p class="title">{{ circle.name }}</p>
                                        <p class="subtitle">{{ circle.description }}</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item">
                                        <!--button
                                            v-if="!isParticipant"
                                            v-t="'Community.join_circle_button'"
                                            :class="{ 'is-loading': joining }"
                                            class="button is-secondary"
                                            @click="joinCircle"
                                        /-->
                                        <p class="subtitle is-6">
                                            {{ circle.participants.length }}
                                            {{
                                            $t(
                                            'Community.participants_count'
                                            )
                                            }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div class="flex flex-col flex-grow overflow-auto p-4">
                <button
                    v-if="pendingMessages"
                    v-t="'Community.fetch_old_messages'"
                    :class="{ 'is-loading': loadingMessages }"
                    class="button is-fullwidth px-2 py-2"
                    @click="fetchOldMessages"
                ></button>
                <div v-for="(messages, date) in dateSections" :key="date">
                    <div class="lb-circle-messages-separator has-text-grey-light">{{ date }}</div>
                    <comment
                        v-for="(comment, index) in messages"
                        :ref="comment._id"
                        :key="comment._id"
                        :dropdown="index == 0"
                        :show-avatar="
                            messages[index - 1] &&
                            messages[index - 1].owner._id != comment.owner._id
                        "
                        :comment="comment"
                        @edit="editComment"
                        @delete="deleteComment"
                        @reply="replyMessage"
                        @zoom="openImage"
                    />
                </div>
                <div v-if="circle.messages.length">
                    <div class="lb-circle-messages-separator has-text-grey-light">
                        <p v-t="'Community.circle_pending_messages_section'"></p>
                    </div>
                    <comment
                        v-for="(comment, index) in circle.messages"
                        :ref="comment._id"
                        :key="comment._id"
                        :dropdown="index == 0"
                        :show-avatar="
                            circle.messages[index - 1] &&
                            circle.messages[index - 1].owner._id !=
                                comment.owner._id
                        "
                        :comment="comment"
                        @edit="editComment"
                        @delete="deleteComment"
                        @zoom="openImage"
                    />
                </div>
            </div>
            <div class>
                <community-message-input-bar
                    v-if="isParticipant"
                    :pre-message="editingMessage"
                    :suggestions="circle.participants"
                    class="p-4"
                    @comment="addComent"
                    @updateComment="updateComment"
                >
                    <template>
                        <article
                            v-if="repliedMessage"
                            class="message is-marginless has-text-weight-medium"
                        >
                            <div class="message-body level">
                                <p v-html="repliedMessage.message"></p>
                                <button
                                    class="delete is-pulled-right"
                                    @click="repliedMessage = undefined"
                                ></button>
                            </div>
                        </article>
                    </template>
                </community-message-input-bar>
            </div>
        </div>
    </div>
</template>

<script>
import CommunityMessageInputBar from '@/components/CommunityMessageInputBar';
import CommunityCircleMessage from '@/components/CommunityCircleMessage';
import {
    sendMessageToCircle,
    fetchItem,
    joinCircle,
    fetchCircleMessages,
    updateMessageFromCircle,
    deleteMessageFromCircle,
    exitCircle,
} from '@/services/API';
import _ from 'underscore';
import moment from 'moment';
const nanoid = require('nanoid');
export default {
    components: {
        CommunityMessageInputBar,
        Comment: CommunityCircleMessage,
    },
    beforeRouteLeave(to, from, next) {
        this.exited = true;
        this.registerExit();
        next();
    },
    data() {
        return {
            comments: [],
            circle: {},
            eventSource: undefined,
            loadingMessages: false,
            pendingMessages: false,
            editingMessage: {},
            joining: false,
            exited: false,
            repliedMessage: undefined,
        };
    },
    metaInfo() {
        return {
            title:
                this.circle.name + ' - ' + this.$store.getters.community.title,
            titleTemplate: '%s - Labylok',
        };
    },
    computed: {
        circle_id() {
            return this.$route.params.id;
        },
        isParticipant() {
            return true; //this.circle.accessLevel == 'PARTICIPANT'; // forcing to true because any member of the community can send messages to community without the need of joining circle
        },
        sortedComments() {
            return _.sortBy(this.comments, (item) => {
                return new Date(item.created).getTime();
            });
        },
        dateSections() {
            const sections = _.groupBy(this.comments, (item) => {
                return moment(item.created).format('DD/MM/YYYY');
            });

            const orderedSections = {};
            Object.keys(sections)
                .sort(function (a, b) {
                    return (
                        moment(a, 'DD/MM/YYYY').toDate() -
                        moment(b, 'DD/MM/YYYY').toDate()
                    );
                })
                .forEach(function (key) {
                    orderedSections[key] = sections[key];
                });
            return orderedSections;
        },
    },
    watch: {
        circle: {
            deep: true,
            handler() {
                this.comments = _.filter(
                    this.circle.last_messages,
                    (message) => {
                        return (
                            _.findWhere(this.circle.messages, {
                                _id: message._id,
                            }) == undefined
                        );
                    }
                );
                this.pendingMessages = this.comments.length;
            },
        },
    },
    created() {
        window.addEventListener('beforeunload', this.registerExit);
    },
    mounted() {
        this.fetchCircle();
        const url = new URL(process.env.VUE_APP_MERCURE_URL);
        url.searchParams.append('topic', 'http://circle.' + this.circle_id);
        this.eventSource = new EventSource(url);
        this.eventSource.onmessage = this.onMessageReceived;
    },
    beforeDestroy() {
        // this is not called on router change.
        if (false === this.exited) {
            this.registerExit();
        }
        this.eventSource.close();
        window.removeEventListener('beforeunload', this.registerExit);
    },
    methods: {
        registerExit() {
            const lastMessage = _.last(this.comments);
            if (_.isEmpty(lastMessage)) {
                return;
            }
            exitCircle(this.circle._id, lastMessage);
        },
        async fetchOldMessages() {
            if (this.loadingMessages || !this.sortedComments.length) {
                return;
            }
            this.loadingMessages = true;
            const oldMessages = await fetchCircleMessages(
                this.circle_id,
                this.sortedComments[0].created
            )
                .catch()
                .finally(() => {
                    this.loadingMessages = false;
                });
            this.comments.unshift(...oldMessages.data);
            this.pendingMessages = oldMessages.data.length >= 15;
        },
        onMessageReceived({ data }) {
            const dataReceived = JSON.parse(data);
            const message = dataReceived.object;
            if (!_.contains(_.pluck(this.comments, '_id'), message._id)) {
                const messageIndex = _.findIndex(this.comments, {
                    _id: message.localId,
                });
                if (messageIndex > -1) {
                    this.comments.splice(messageIndex, 1, message);
                } else {
                    this.comments.push(message);
                }

                this.scrollToLastMessage();
            }
        },
        async addComent({ message, media }) {
            if (message.length <= 1 && !media) {
                return;
            }
            const comment = {
                message,
                media,
                reply: this.repliedMessage,
                owner: this.$store.getters.user,
                _id: nanoid(5),
            };
            this.comments.push(comment);
            this.scrollToLastMessage();
            sendMessageToCircle(this.circle_id, comment).finally(() => {
                this.repliedMessage = undefined;
            });
        },

        replyMessage(message) {
            this.repliedMessage = message;
        },
        async fetchCircle() {
            fetchItem('circle', this.circle_id)
                .then(({ data }) => {
                    this.circle = data;

                    this.$nextTick(() => {
                        this.$store.commit(
                            'CLEAR_PENDING_MESSAGES',
                            this.circle_id
                        );
                        this.scrollToLastMessage();
                    });
                })
                .catch((e) => {});
        },

        async joinCircle() {
            this.joining = true;
            const joinResult = await joinCircle(this.circle_id)
                .catch(() => {})
                .finally(() => {
                    this.joining = false;
                });
            this.circle = joinResult.data;
        },
        scrollToLastMessage() {
            const lastMessage = _.last(this.comments);
            if (lastMessage) {
                this.$nextTick(() => {
                    this.$refs[lastMessage._id][0].$el.scrollIntoView({
                        behavior: 'smooth',
                    });
                });
            }
        },
        editComment(comment) {
            this.editingMessage = comment;
        },
        async updateComment(object, text) {
            let editingComment = object;
            editingComment.message = text;
            updateMessageFromCircle(editingComment)
                .then(({ data }) => {
                    const updatedIndex = _.findIndex(this.comments, {
                        _id: data._id,
                    });
                    this.comments.splice(updatedIndex, 1, data);
                })
                .catch((e) => {});
            this.editingMessage = {};
        },
        async deleteComment(object) {
            deleteMessageFromCircle(object)
                .then(({ data }) => {
                    const updatedIndex = _.findIndex(this.comments, {
                        _id: data._id,
                    });
                    this.comments.splice(updatedIndex, 1, data);
                })
                .catch((e) => {});
        },
        openImage(media) {},
    },
};
</script>
<style lang="scss">
@import 'src/assets/sass/chat';
</style>

<style scoped lang="css">
.lb-circle-container {
    height: calc(100vh - 3.75rem);
}

.lb-circle-messages-separator {
    display: flex;
    align-items: center;
    text-align: center;
}

.lb-circle-messages-separator::before,
.lb-circle-messages-separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #eceded;
}

.lb-circle-messages-separator:not(:empty)::before {
    margin-right: 0.25em;
}

.lb-circle-messages-separator:not(:empty)::after {
    margin-left: 0.25em;
}
</style>
